<input type="text" class="hidden-input" />
@if (inviteMode()) {
  <div class="header">
    <button
      appButton
      name="back"
      location="share-gallery-collaborators"
      [iconButton]="true"
      color="simple-gray"
      height="0"
      (click)="inviteMode.set(false)"
    >
      <app-svg src="/assets/icons/arrow-left.svg"></app-svg>
    </button>
    <h1>Add Collaborators</h1>
  </div>
} @else {
  <div class="header">
    <h1>Share Gallery</h1>
  </div>
}

@if (isSubGallery()) {
  <div class="sub-gallery-warning">
    <div class="icon">
      <app-svg src="/assets/icons/info-circle.svg"></app-svg>
    </div>

    <div class="content">
      <h3>This is a Sub-Gallery</h3>
      <p>Manage access on the main gallery.</p>
    </div>

    <button
      appButton
      name="manage-main-gallery"
      location="share-gallery-collaborators"
      color="grey-50"
      shape="round"
      height="1"
      size="1"
      weight="bold"
      spacing="3"
      (click)="openMainGalleryShareDialog()"
    >
      Manage
    </button>
  </div>
} @else {
  <app-emails-entry-field
    #emailsEntryField
    (onChange)="onEmailChange($event); $event?.[1] && inviteMode.set(true)"
    [autoCompleteMethod]="autocompleteMethod()"
    (onBlur)="onBlur()"
    (onFocus)="onFocus()"
    [validationMethod]="validateEmail()"
    [validationErrorMessageMethod]="getEmailErrorMessage()"
    [customPlaceholder]="'Add Collaborators...'"
    [verticallyCenter]="true"
  >
    @if (inviteMode()) {
      <app-gallery-share-context
        class="email-field-access-context"
        [currentAccessLevel]="inviteAccessLevel()"
        [accessLevels]="inviteAccessLevels"
        (onChange)="inviteAccessLevel.set($event)"
        [type]="'gallery'"
        [mode]="'invite-field'"
      ></app-gallery-share-context>
    }
  </app-emails-entry-field>
}

@if (inviteMode()) {
  <div class="invite-mode" [class.autocomplete-mode]="showAutocompleteResults() && autocompleteResults().length">
    @if (showAutocompleteResults() && autocompleteResults().length) {
      <div class="autocomplete-container">
        <app-autocomplete-results
          [results]="autocompleteResults()"
          [noShadow]="true"
          (onSelect)="selectAutocompleteResult($event)"
          (onAutoSelectIndex)="autoCompleteIndex.set($event)"
        ></app-autocomplete-results>
      </div>
    } @else {
      <form [formGroup]="messageForm">
        <label for="do-notify" class="switch-container">
          <app-switch appClickTrack name="do-notify" [extra]="{ notify: !messageForm.value.notify }">
            <input type="checkbox" id="do-notify" formControlName="notify" />
            <label for="do-notify" data-test-id="do-notify"></label>
          </app-switch>
          <span>Notify People</span>
        </label>
        @if (messageForm.value.notify) {
          <app-input-field [control]="messageForm.controls.message" [noLabel]="true">
            <textarea formControlName="message" placeholder="Add message... (optional)"></textarea>
          </app-input-field>
        }
      </form>

      <div class="invite-mode-footer">
        <p class="standard-text small invite-info">
          People new to Picflow will be invited to create an account.
          <a href="https://help.picflow.com/en/articles/7019139" target="_blank" class="primary-link">Learn more</a>
        </p>
        <div class="spacer"></div>
        <button
          appButton
          name="add-people"
          location="share-gallery-collaborators"
          height="3"
          heightMobile="2"
          (click)="sendInvites()"
          color="primary"
          width="160"
          shape="round"
          class="done-button"
          data-test-id="add-people"
        >
          <span [class.hidden-text]="sendingInvites()">
            @if (messageForm.value.notify) {
              @if (emailsEntryField().emails().length < 2) {
                Send Invite
              } @else {
                Send Invites
              }
            } @else {
              @if (emailsEntryField().emails().length < 2) {
                Add Person
              } @else {
                Add People
              }
            }
          </span>
          @if (sendingInvites()) {
            <app-loading-indicator color="white" size="small" class="button-loading-indicator"> </app-loading-indicator>
          }
        </button>
      </div>
    }
  </div>
} @else {
  <div class="access-items">
    @if (loading()) {
      <div class="loading-access-items">
        <app-loading-indicator></app-loading-indicator>
      </div>
    } @else {
      <app-gallery-public-access-item
        [gallery]="gallery()"
        (editLink)="editLink.emit()"
      ></app-gallery-public-access-item>
      <app-gallery-team-access-item
        [gallery]="gallery()"
        [galleryPermissions]="galleryPermissions()"
      ></app-gallery-team-access-item>
      @if (('groups:list' | billingScope) && isTeamMember()) {
        @for (data of galleryUserGroups(); track data.group.id) {
          <app-gallery-user-group-access-item
            [gallery]="mainGallery()"
            [group]="data.group"
            [groupAccessLevel]="data.accessLevel"
            [galleryPermissions]="galleryPermissions()"
          ></app-gallery-user-group-access-item>
        }
      }

      @if (owner(); as owner) {
        <app-gallery-owner-access-item [owner]="owner"></app-gallery-owner-access-item>
      }

      @for (member of galleryMembers(); track member.id) {
        <app-gallery-member-access-item
          [gallery]="mainGallery()"
          [member]="member"
          [memberAccess]="member.access"
          [galleryPermissions]="galleryPermissions()"
          [isTeamMember]="isTeamMember()"
          [galleryOwner]="owner()"
        ></app-gallery-member-access-item>
      }

      @for (invite of galleryInvites(); track invite.id) {
        <app-gallery-invite-access-item
          [invite]="invite"
          [inviteAccess]="invite.access"
          [galleryPermissions]="galleryPermissions()"
        ></app-gallery-invite-access-item>
      }
    }
  </div>
}
